import { IWidgetConfiguration } from '../models';
import { RowSpacing, AggregationConfiguration, TimeInterval, PeriodReference, AggregationMode, NameBuilderConfiguration } from '../../models';
import { RowConfiguration } from './tableRows/tableRow.configuration';
import { ITableConfiguration } from './ITableConfiguration';
import { IPresentationUnitConfiguration } from '../models/interfaces';

export class TableWidgetConfiguration implements IWidgetConfiguration, ITableConfiguration {
    aggregation: AggregationConfiguration;
    aggregationColumnMode: AggregationMode;
    alignedOn: PeriodReference;
    dateFormat?: string;
    hasTrend?: boolean;
    isEndDateIncluded = false;
    isQualityVisible: boolean;
    isVertical: boolean;
    maxColumns: number;
    maxPeriod: TimeInterval;
    minPeriod: TimeInterval;
    nameConfiguration?: NameBuilderConfiguration;
    options: IPresentationUnitConfiguration;
    rowSpacing: RowSpacing;
    rows: RowConfiguration[];
    showLogbook: boolean;
    showOwnFields: boolean;

    constructor() {
        this.rows = [];
        this.aggregation = new AggregationConfiguration();
        this.aggregationColumnMode = AggregationMode.None;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.nameConfiguration.hasName = true;
        this.maxColumns = 31;
        this.alignedOn = PeriodReference.End;
        this.rowSpacing = RowSpacing.Normal;
        this.showOwnFields = false;
    }
}
